import './index.css';

import { LocalizationProvider, DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import { DEFAULT_COMPONENT_HEIGHT } from '../../../constants';
import Locale from '../../enums/locale.ts';
import { useContext, useEffect, useState } from 'react';
import type RootContextProps from '../../../types/root-context-props.ts';
import { RootContext } from '../../../main.tsx';

type DatepickerProps = {
  name: string;
  value: Dayjs | undefined;
  onChange?: (value: Dayjs | null) => void;
  isError?: boolean;
  isRequired?: boolean;
  disabled?: boolean;
  minDate?: Dayjs | undefined;
  maxDate?: Dayjs | undefined;
  label?: string | React.ReactElement;
  fontSize?: string;
};

const DatePicker: React.FunctionComponent<DatepickerProps> = (props: DatepickerProps) => {
  const context: RootContextProps = useContext(RootContext);

  const [locale, setLocale] = useState(context.locale === Locale.RU ? 'ru' : 'en');

  const onDateClean = () => {
    if (props?.onChange) {
      props.onChange(null);
    }
  };

  const onDateChange = (newDate: Dayjs | null) => {
    if (props?.onChange && newDate !== undefined) {
      props.onChange(newDate);
    }
  };

  useEffect(() => {
    setLocale(context.locale === Locale.RU ? 'ru' : 'en');
  }, [context.locale]);

  useEffect(() => {
    dayjs.locale(locale);
  }, [locale]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDatePicker
        label={props?.label || null}
        format="DD.MM.YYYY"
        value={props.value}
        onChange={onDateChange}
        minDate={props?.minDate}
        maxDate={props?.maxDate}
        slotProps={{
          field: { clearable: true, onClear: () => onDateClean },
        }}
        sx={{
          '& .MuiInputBase-root': {
            height: DEFAULT_COMPONENT_HEIGHT,
          },
          '& input': {
            fontSize: props.fontSize || 'var(--main-font-size)' + 2,
          },
        }}
        disabled={props.disabled}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
